import { AssetMaintenanceItemComponentBase } from './asset-maintenance-item.component.base';
import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, requiredValidator, UserStorage } from '@scisys-uim/uim-common';
import { ASSET_TYPE, Firearm, FIREARM_TYPE } from 'assets-model';
import { AssetMaintenanceService, AssetService, FirearmService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-asset-maintenance-item',
  templateUrl: './asset-maintenance-item.component.html',
  styleUrls: ['./asset-maintenance-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class AssetMaintenanceItemComponent extends AssetMaintenanceItemComponentBase {

  constructor(
    protected assetMaintenanceService: AssetMaintenanceService,
    protected assetService: AssetService,
    protected firearmService: FirearmService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(assetMaintenanceService, assetService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.assetLoadSelectionList();
    this.maintenanceTypeLoadSelectionList();

    if (this.createMode) {
      if (this.composedAssetClassParameter === 'Asset') {
        this.assetService.get(this.assetId).subscribe(
          (data) => {
            this.item.asset = data;
            this.item.assetId = this.assetId;
          });
      } else if (this.composedAssetClassParameter === 'Firearm') {
        this.firearmService.get(this.assetId).subscribe(
          (data) => {
            this.item.asset = data.asset;
            this.item.assetId = this.assetId;
          });
      }
    }
  }

  itemSet() {
    super.itemSet();
    if (this.createMode) {
      this.item.createdDate = new Date();
      this.item.createdBy = this.userDetails?.username;
    }
  }

  createForm(): FormGroup {
    return this.fb.group({
      assetMaintenanceId: [null, []],
      asset: [null, [requiredValidator,]],
      assetId: [null, []],
      comments: [null, [requiredValidator,]],
      createdBy: [null, []],
      createdDate: [null, []],
      maintenanceBy: [null, [requiredValidator,]],
      maintenanceDate: [null, [requiredValidator,]],
      maintenanceType: [null, [requiredValidator,]]
    });
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    this.assetMaintenanceId.disable();
    this.asset.disable();
    this.createdDate.disable();
    this.createdBy.disable();
  }

  get assetId() {
    return this.routeParams?.assetId;
  }

  get composedAssetClassParameter() {
    return this.getCombinedParams()?.composedAssetClass;
  }

  assetLoadSelectionList() {
    if (this.composedAssetClassParameter === 'Asset' || this.item?.asset?.composedAssetClass === 'Asset') {
      this.assetService.findAll().subscribe(
        data => {
          this.assetSelectionList = ASSET_TYPE.entityDecorator.ensureContained(this.item && this.item.asset, data.items);
        });
    } else if (this.composedAssetClassParameter === 'Firearm' || this.item?.asset?.composedAssetClass === 'Firearm') {
      this.firearmService.findAll().subscribe(data => this.assetSelectionList = data.items.map(firearm => firearm.asset));
    }


  }
}

